// extracted by mini-css-extract-plugin
export default {"component":"Details_component__uYlPC"};